import { logger } from '../logger'
import { EventSenderPlugin } from './plugins'
import { AmplitudePlugin } from './plugins/Amplitude'
import { ClarityPlugin } from './plugins/Clarity'
import { GoogleAnalyticsPlugin } from './plugins/GoogleAnalytics'
import { ServerEventPlugin } from './plugins/ServerEvent'
import { Metadata, SendEventData } from './types'

export class EventSenderManager {
  private plugins: EventSenderPlugin[] = []
  private userMetadata: Metadata = {}
  private eventMetadata: Metadata = {}

  init() {
    this.plugins.forEach((plugin) => {
      try {
        plugin.init?.()
      } catch (error) {
        logger.error(`Error initializing plugin ${plugin.name}:`, error)
      }
    })
  }

  addPlugin(plugin: EventSenderPlugin) {
    if (!this.plugins.some((p) => p.name === plugin.name)) {
      this.plugins.push(plugin)
    }
  }

  removePlugin(pluginName: string) {
    this.plugins = this.plugins.filter((plugin) => plugin.name !== pluginName)
  }

  sendEvent(event: SendEventData) {
    const mergedEvent = {
      ...event,
      metadata: {
        ...this.eventMetadata,
        ...event.metadata
      }
    }
    this.plugins.forEach((plugin) => {
      try {
        plugin.sendEvent(mergedEvent)
      } catch (error) {
        logger.error(`Error sending event with plugin ${plugin.name}:`, error)
      }
    })
  }

  updateUserMetadata(metadata: Metadata) {
    this.userMetadata = { ...this.userMetadata, ...metadata }
    this.plugins.forEach((plugin) => {
      try {
        plugin.updateUserMetadata?.(this.userMetadata)
      } catch (error) {
        logger.error(`Error updating metadata in plugin ${plugin.name}:`, error)
      }
    })
  }

  updateEventMetadata(metadata: Metadata) {
    this.eventMetadata = { ...this.eventMetadata, ...metadata }
  }
}

const eventSenderManager = new EventSenderManager()
const serverEvent = new ServerEventPlugin({ sendOnlyMetricEvents: true })

eventSenderManager.addPlugin(new ClarityPlugin())
eventSenderManager.addPlugin(new GoogleAnalyticsPlugin())
eventSenderManager.addPlugin(new AmplitudePlugin())
eventSenderManager.addPlugin(serverEvent)
eventSenderManager.init()

export { eventSenderManager, serverEvent }
